/**
 * Created by eatin on 2017/11/20.
 */
import HttpRequest from '../jslib/HttpRequest'
import {appDomain, domain} from "../jslib/env"
import md5 from 'js-md5'
import pay from "../js/pay/pay"

// 获取七牛根目录
const getBucketDomain = data=> {
  return HttpRequest({
    url: 'qiniu/getBucketDomain',
    data,
    method: "post"
  })
}


// 获取城市
const getCity = data=> {
  return HttpRequest({
    url: 'userArea/getCity2',
    params:data,
    method: 'post'
  })
}

// 查询楼盘列表
const getBuildingsList = data=> {
  return HttpRequest({
    url: 'MyHomeBuildings/lists',
    params:data,
  })
}

// 获取楼盘的分类数据结构
const getBuildingsInfo = data=> {
  return HttpRequest({
    url: 'MyHomeBuildings/getBuildingsInfo',
    params:data,
    method: 'post'
  })
}

// 获取楼盘的所有户型
const getBuildingsType = data=> {
  return HttpRequest({
    url: 'MyHomeBuildings/alls',
    params:data,
    method: 'post'
  })
}

// 根据分类id查询推荐案例
const getUnitDecorates = data=> {
  return HttpRequest({
    url: 'MyHomeBuildings/getUnitDecorates',
    params:data,
    method: 'post'
  })
}

// 根据户型id查询推荐案例
const getHouseDecorates = data=> {
  return HttpRequest({
    url: 'MyHomeBuildings/getHouseDecorates',
    params:data,
    method: 'post'
  })
}

// 获取案例详情
const getDecoratesInfo = data=> {
  return HttpRequest({
    url: 'MyHomeBuildings/getDecoratesInfo',
    params:data,
    method: 'post'
  })
}

// 获取热门楼盘
const getHotBuildings = (data) => {
  return HttpRequest({
    url: 'MyHomeBuildings/getHotBuildings',
    data,
    method:'post'
  })
}

// 获取热门城市
const getHotCitys = (data) => {
  return HttpRequest({
    url: 'MyHomeBuildings/getHotCitys',
    data,
    method:'post'
  })
}


// 根据楼盘获取户型列表
const getHouseType = data=> {
  return HttpRequest({
    url: 'MyHomeBuildings/getHouseType',
    params:data,
  })
}

// 获取户型详情
const getInfo = data=> {
  return HttpRequest({
    url: 'MyHomeHouseType/getInfo',
    params:data,
  })
}

// 获取户型装修方案
const getDecorateProgramList = data=> {
  return HttpRequest({
    url: 'myHomeHouseType/getDecorateProgramList',
    params:data,
  })
}

// 保存用户完整门牌地址
const saveAddr = data=> {
  return HttpRequest({
    url: 'MyHomeBuildings/saveUserBuildingData',
    params:data,
  })
}

//获取调研数据
const getSurveyQuestion = data => {
  return HttpRequest({
    url: '/Survey/datas',
    params:data,
    method:'post'
  })
}
//提交数据
const submitSurveyData = data => {
  return HttpRequest({
    url: '/Survey/save',
    params:data,
    method:'post'
  })
}
//获取用户填写的调研数据
const getSurveyData = data => {
  return HttpRequest({
    url: '/user/get_label_info',
    params:data,
    method:'post'
  })
}

//产品列表
const getProductList = data => {
  return HttpRequest({
    url: '/MyHomeBuildings/getProductList',
    data,
    method:'post'
  })
}

//产品详情
const getProductDetail = data => {
  return HttpRequest({
    url: '/MyDecorateProductCart/read',
    data,
    method:'post'
  })
}

//收藏or取消
const collectProduct = data => {
  return HttpRequest({
    url: '/MyDecorateProductCart/collect',
    data,
    method:'post'
  })
}


//收藏or取消（商城）
const collectProductMall = data => {
  return HttpRequest({
    url: '/ShopIndex/collect',
    data,
    method:'post'
  })
}


//收藏or取消（定制）
const collectProductCustom = data => {
  return HttpRequest({
    url: '/works/worksCollect',
    data,
    method:'post'
  })
}

// 收藏 (商品通用)
const collect = data => {
  return HttpRequest({
    url: 'User/collect',
    data,                   // 收藏项目类型: 'shop_product'-商城商品,'decorate_product'-整配产品,'customized_product'-定制产品,'decorate_program'-整配方案
    method:'post'
  })
}

// 取消收藏 (商品通用)
const cancelCollect = data => {
  return HttpRequest({
    url: 'User/cancelCollect',
    data,
    method:'post'
  })
}

//编辑或重新定制方案（安卓）
const updateProduct = data => {
  return HttpRequest({
    url: '/Scheme/updateProduct',
    data,
    method:'post'
  })
}

//获取活动详情信息
const getUserActiveInfo = data => {
  return HttpRequest({
    url: '/userActivity/info',
    data,
    method:'post'
  })
}

//资讯详情 about_us 关于我们
const getPageInfo = data => {
  return HttpRequest({
    url: '/SimplePage/getPageInfo',
    data,
    method:'post'
  })
}

// 消息详情
const userMessageDetail = data => {
  return HttpRequest({
    url: '/User/myMessageDetail',
    data,
    method:'post'
  })
}

//是否符合活动详情
const userEventLegitimate = data => {
  return HttpRequest({
    url: '/userActivity/checkUser',
    data,
    method:'post'
  })
}

//获取当前用户地址
const getUserBuildingData = data => {
  return HttpRequest({
    url: '/MyHomeBuildings/getUserBuildingData',
    data,
    method:'post'
  })
}

//加入购物车 （商城）
const addProductCartMall = data => {
  return HttpRequest({
    url: '/ShoppingCart/add',
    data,
    method:'post'
  })
}


//加入购物车 （整配）
const addProductCart = data => {
  return HttpRequest({
    url: '/MyDecorateProductCart/add',
    data,
    method:'post'
  })
}

//加入购物车 （定制）
const addProductCartCustom = data => {
  return HttpRequest({
    url: '/Scheme/addShopCart',
    data,
    method:'post'
  })
}

//新购物车列表
const getNewProductCart = data => {
  return HttpRequest({
    url: 'MyDecorateProductCart/alllists',
    data,
    method:'post'
  })
}

//购物车列表
const getProductCart = data => {
  return HttpRequest({
    url: 'MyDecorateProductCart/lists',
    data,
    method:'post'
  })
}

//购物车类型数量
const getProductCartInfo = data => {
  return HttpRequest({
    url: 'MyDecorateProductCart/info',
    data,
    method:'post'
  })
}

//购物车删除
const delProductCart = data => {
  return HttpRequest({
    url: 'MyDecorateProductCart/delete',
    data,
    method:'post'
  })
}

//购物车更新
const updateProductCart = data => {
  return HttpRequest({
    url: 'MyDecorateProductCart/update',
    data,
    method:'post'
  })
}

//花色列表
const getColorList = data => {
  return HttpRequest({
    url: 'MyDecorateProductCart/colorList',
    data,
    method:'post'
  })
}

//商品类规格
const getStandardList = data => {
  return HttpRequest({
    url: 'MyDecorateProductCart/standardList',
    data,
    method:'post'
  })
}

//购物车去结算前检查
const checkBeforePay = data => {
  return HttpRequest({
    url: 'Order/preInfoCheck',
    data,
    method:'post'
  })
}

//结算
const getComplete = (type, data) => {
  return HttpRequest({
    url: 'Scheme'+type+'/complete2',
    data,
    method:'post'
  })
}

// 发送验证码
const sendSms = data => {
  return HttpRequest({
    url: 'sms/sendSms',
    data,
    method:'post'
  })
}

// 用户注册
const register = data => {
  return HttpRequest({
    url: 'index/register_h5',
    data,
    method:'post'
  })
}

// 用户注册/登录
export const loginCode = data => {
  return HttpRequest({
    url: 'index/login_code',
    data,
    method:'post',
    headers:{'client-type': 3}
  })
}

// 用户登录
const login = data => {
  data.password = md5(data.password + 'dankal')
  return HttpRequest({
    url: 'index/login',
    data,
    method:'post'
  })
}

// 获取微信用户信息Token
const getWxAccessToken = (code) => {
  let appId = 'wx7977941a06563864'
  return HttpRequest({
    url: `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${appId}&secret=SECRET_CODE&code=${code}&grant_type=authorization_code`,
    method:'post'
  })
}

// 微信用户信息
const getUserWxInfo = (data) => {
  let {access_token, openid} = data
  return HttpRequest({
    url: `https://api.weixin.qq.com/sns/userinfo?access_token=${access_token}&openid=${openid}&lang=zh_CN`,
    method:'post'
  })
}

// 微信分享配置信息
const getWxJsSdkConfig = data => {
  return HttpRequest({
    url: 'system/getWxJsSdkConfig',
    data,
    method:'post'
  })
}

// 用户行为统计 {"event_key":"",event_value:{}}
const userEventLog = data => {
  return HttpRequest({
    url: '/User/eventLog',
    params: data,
    method: 'post'
  })
}


// --- 团减活动 ---

// 优惠券活动详情
const couponActivityInfo = (data) =>{
  return HttpRequest({
    url: `UserActivity/couponActivityInfo`,
    data,
    method:'post'
  })
}

// 团购详情
const couponGroupInfo = (data) => {
  return HttpRequest({
    url: 'coupon/groupInfo?group_id='+data.group_id,
    // data,                                            // 用data访问时会现500错误
    method:'post'
  })
}

// 购买团券前检查
const couponPayCheck = (data) => {
  return HttpRequest({
    url: 'coupon/payCheck',
    data,
    method:'post'
  })
}

// 加入团验证
const couponJoinGroupCheck = (data) => {
  return HttpRequest({
    url: 'coupon/joinGroupCheck',
    data,
    method:'post'
  })
}

// 加入团并支付
const couponJoinGroupPay = (data) => {

  pay.clearWxCode() // 支付发起后清除微信授权code

  return HttpRequest({
    url: 'coupon/joinGroupPay',
    data,
    method:'post'
  })
}

// 支付 (券)
const couponPay = (data) => {

  pay.clearWxCode() // 支付发起后清除微信授权code

  return HttpRequest({
    url: 'Coupon/pay',
    data,
    method:'post'
  })
}



// --- 填写订单页面 ---

/**
 * 获取订单信息
 * @param {Object} data - 请求参数对象
 * @param {Array<String>} data.cart_id - 购物车id数组
 * @param {String} data.type - 安卓：android，苹果：ios
 * @param {String} data.user_coupon_id - 用户的优惠券表主键ID，-1表示不使用优惠券
 * */
const orderPreInfo = (data) => {
  return HttpRequest({
    url: 'Order/preInfo',
    data,
    method:'post'
  })
}

// 获取我的收货地址
const userAreaGetList = (data)=>{
  return HttpRequest({
    url: 'UserArea/getList',
    data,
    method:'post'
  })
}

// 获取地域列表
const getConfigAddress = (data)=>{
  return HttpRequest({
    url: 'user_area/getConfigAddress',
    data,
    method:'post'
  })
}

// 添加收货地址
const userAreaAdd = (data)=>{
  return HttpRequest({
    url: 'UserArea/add',
    data,
    method:'post'
  })
}

// 删除收货地址
const userAreaDelete = (data) => {
  return HttpRequest({
    url: 'userArea/delete',
    data,
    method:'post'
  })
}

// 修改收货地址
const userAreaEdit = (data) => {
  return HttpRequest({
    url: 'UserArea/edit',
    data,
    method:'post'
  })
}

/**
 * 功能： 购物车支付
 * @param {Object} data
 * @param {Array<String>} data.cart_id - 购物车id
 * @param {String} data.area_id - 收货地址id
 * @param {String} data.delivery_time - 送达/安装时间 (10位时间戳)
 * @param {String} data.trade_type - 终端类型（APP,JSAPI,NATIVE）
 * @param {String} data.pay_type - 支付方式alipay，wechat
 * @param {String} data.user_remarks - 备注/留言
 * @param {Number} data.user_coupon_id - 用户的优惠券表主键ID，-1表示不使用优惠券
 * @param {String} data.code - 微信公众账号授权code
 * */
const orderCreate = (data) => {

  pay.clearWxCode() // 支付发起后清除微信授权code

  return HttpRequest({
    url: 'Order/create',
    data,
    method:'post'
  })

}

/**
 * 重新支付
 * @param {Object} data
 * @param {String} data.supplier_num - 订单编号
 * @param {String} data.pay_type - 支付方式alipay，wechat
 * @param {String} data.code - 微信公众账号授权code,如果是wechat,JSAPI,则该参数必传
 * */
const orderContinuePay = (data) => {

  pay.clearWxCode() // 支付发起后清除微信授权code

  data.trade_type = 'JSAPI'                 // 终端类型（APP,JSAPI,NATIVE）

  return HttpRequest({
    url: 'Order/continuePay',
    data,
    method:'post'
  })

}


// --- 无人样板间预约 ---

// 可以预约的样板间
const houseShowGetList = () => {
  return HttpRequest({
    url: 'HouseShow/getList',
    method:'post'
  })
}

/**
 * 提交样板间预约
 * @param {Object|JSON} data = {
 *                      	"appointment_json": {
 *                      		"owner_config_id": 0,
 *                      		"owner_user_name": "",
 *                      		"appointment_data": [
 *                      		  {
 *                      		    "house_show_id": 0,
 *                      		    "appointment_time": 0
 *                      		  }
 *                      		]
 *                      	}
 *                      }
 * */
const houseShowAppointment = data => {
  return HttpRequest({
    url: 'HouseShow/appointment',
    data,
    method:'post'
  })
}


// --- 三维定制柜体(榻榻米) ---

/** 获取柜体方案详情
 * @param data.scheme_id
 * @param {'own'|'other'} data.type - own 自己的方案, other 其他人的方案
 */
const schemeGetInfo = ({scheme_id, type = 'other'}) => {
    return HttpRequest({
        url: 'scheme/getInfo',
        data: {scheme_id, type},
        method:'post'
    })
}

// --- 内部测试使用 ---

//清空用户活动、调研完成度、地址门牌号信息
const clearUserData = data => {
  return HttpRequest({
    url: 'User/clearUserData',
    data,
    method:'post'
  })
}


export {
  getBucketDomain,
  getCity,
  getBuildingsList,
  getBuildingsInfo,
  getBuildingsType,
  getUnitDecorates,
  getHouseDecorates,
  getDecoratesInfo,

  getHotBuildings,
  getHotCitys,

  getHouseType,
  getInfo,
  getPageInfo,
  userMessageDetail,
  saveAddr,
  getDecorateProgramList,
  getSurveyQuestion,
  submitSurveyData,
  getSurveyData,
  getUserBuildingData,
  getProductList,
  getProductDetail,
  collectProduct,
  collectProductMall,
  collectProductCustom,
  collect,
  cancelCollect,
  getUserActiveInfo,
  userEventLegitimate,
  updateProduct,
  addProductCart,
  addProductCartCustom,
  addProductCartMall,
  getNewProductCart,
  getProductCart,
  getProductCartInfo,
  delProductCart,
  updateProductCart,
  getColorList,
  getStandardList,
  checkBeforePay,
  getComplete,
  sendSms,
  register,
  login,
  getWxAccessToken,
  getUserWxInfo,
  getWxJsSdkConfig,
  userEventLog,

  couponActivityInfo,
  couponGroupInfo,
  couponJoinGroupCheck,
  couponJoinGroupPay,
  couponPayCheck,
  couponPay,

  orderPreInfo,
  userAreaGetList,
  getConfigAddress,
  userAreaAdd,
  userAreaDelete,
  userAreaEdit,
  orderCreate,
  orderContinuePay,

  houseShowGetList,
  houseShowAppointment,

  schemeGetInfo,

  clearUserData,
}


// import {getUserInfo,login} from '../api/api.js'

// let data={}
// login({
//   ss:''
// }).then(response=>{
//   var serverRes=response.data
//   return  getUserInfo(data)
//
// }).then(response=>{
//
// }).catch(error=>{
//   console.log(error.messsage)
// })
